var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m11.44 12-5.941 5.942 1.06 1.06 5.942-5.94 5.94 5.94 1.061-1.06L13.562 12l5.94-5.941-1.06-1.061-5.941 5.94L6.559 5 5.5 6.059z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }